import { Injectable } from '@angular/core';
import {MerchantApi} from "../apis/merchant-api";
import {Merchant} from "../interfaces/Merchant";
import {Product} from "../interfaces/Product";
import {BehaviorSubject, Observable} from "rxjs";
import {Rating, RatingApiResponse} from "../interfaces/Rating";

@Injectable({
  providedIn: 'root'
})
export class MerchantService {

  private merchantSubject = new BehaviorSubject<Merchant | null>(null)
  private products = new BehaviorSubject<Product[]>([])
  private ratings = new BehaviorSubject<RatingApiResponse | null>(null)

  constructor(
    private merchantApi: MerchantApi
  ) { }

  loadMerchantInfo(slugName: string) {
    this.merchantApi.getMerchantById(slugName, true).subscribe({
      next: (merchant) => {
        this.merchantSubject.next(merchant)
        this.merchantApi.getProductsByMerchantId(merchant.id, 1).subscribe({
          next: (productsResponse) => {
            this.products.next(productsResponse.data)
          }
        })
        this.loadMerchantRatings(merchant.id)
      }
    })
  }

  getMerchantInfo(): Observable<Merchant | null> {
    return this.merchantSubject
  }

  getProducts(): Observable<Product[]> {
    return this.products
  }

  getRatings(): Observable<RatingApiResponse | null>  {
    return this.ratings
  }

  loadMerchantRatings(merchantId: string) {
    this.merchantApi.getMerchantRatings(merchantId).subscribe({
      next: (ratingsResponse) => {
        this.ratings.next(ratingsResponse)
      }
    })
  }

}
